import React, { memo } from "react";
import NoResults from "../../components/agent-v3/board/no-results/NoResults";

function EmptyTickets({ createTicketRequest }: { createTicketRequest: () => void }) {
    return (
        <NoResults
            title="🤔 Seems like you don't have any tickets now."
            text="Would you like to create a new request?"
            resetButtonText="New Request"
            onClear={createTicketRequest}
        />
    );
}

export default memo(EmptyTickets);
